import React, { type ReactElement } from 'react';

import { type ChatViewMessage } from './store.js';
import { Answer } from '../prompt/Answer.js';
import type { MarkpromptOptions } from '../types.js';

interface MessageAnswerProps {
  children: string;
  state: ChatViewMessage['state'];
  supportOptions?: MarkpromptOptions['support'];
}

export function MessageAnswer(props: MessageAnswerProps): ReactElement {
  const { children, state, supportOptions } = props;
  return (
    <div className="MarkpromptMessageAnswer">
      <Answer answer={children} state={state} supportOptions={supportOptions} />
      {state === 'cancelled' && (
        <div className="MarkpromptCancelled">
          <p className="MarkpromptCancelledText">
            This chat response was cancelled. Please try regenerating the answer
            or ask another question.
          </p>
        </div>
      )}
    </div>
  );
}
